<template>
  <header class="h-20 min-h-[80px] bg-white border-b border-slate-200 flex items-center justify-between px-8 flex-none w-full sticky top-0 z-40">
    
    <h2 class="text-2xl font-black text-pharma-text-main tracking-tight leading-none">
      {{ title }}
    </h2>
    
    <div class="flex items-center gap-6">
      <div v-if="user" class="flex items-center gap-3 pl-6 border-l border-slate-200">
        <div class="text-right">
          <p class="font-bold text-sm text-pharma-text-main leading-tight">{{ user.name }}</p>
          <p class="text-sm font-bold text-primary uppercase tracking-widest mt-0.5">
            {{ user.role }}
          </p>
        </div>
        
        <img 
          :src="`https://ui-avatars.com/api/?name=${formattedName}&background=3b66d1&color=fff&bold=true`" 
          :alt="user.name"
          class="w-10 h-10 rounded-full border border-slate-100 shadow-sm object-cover"
        >
      </div>

      <div v-else class="flex items-center gap-3 animate-pulse">
        <div class="text-right space-y-2">
          <div class="h-3 w-24 bg-slate-100 rounded"></div>
          <div class="h-2 w-16 bg-slate-50 rounded ml-auto"></div>
        </div>
        <div class="w-10 h-10 bg-slate-100 rounded-full"></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    title: {
      type: String,
      default: 'Dashboard'
    }
  },
  computed: {
    user() {
      try {
        // Checking both common storage keys to ensure data is found
        const storedUser = localStorage.getItem('user') || localStorage.getItem('user-data');
        return storedUser ? JSON.parse(storedUser) : null;
      } catch (e) {
        return null;
      }
    },
    formattedName() {
      return this.user?.name ? this.user.name.split(' ').join('+') : 'User';
    }
  }
}
</script>